// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audioSvg_oJKAW {
    display: inline-block;
  }
  
  .bar_zGaEH {
    transform-origin: center center;
    transform-box: fill-box;
    transform: scaleY(1);
    animation: none;
  }
  

  
  .audioSvg_oJKAW.recording_DWHTn .bar1_aD_XT {
    animation: wave_I6PvD 1.2s infinite ease-in-out;
    animation-delay: 0s;
  }
  .audioSvg_oJKAW.recording_DWHTn .bar2_GbX6U {
    animation: wave_I6PvD 1.2s infinite ease-in-out;
    animation-delay: 0.1s;
  }
  .audioSvg_oJKAW.recording_DWHTn .bar3_f8l3w {
    animation: wave_I6PvD 1.2s infinite ease-in-out;
    animation-delay: 0.2s;
  }
  .audioSvg_oJKAW.recording_DWHTn .bar4_m_OI_ {
    animation: wave_I6PvD 1.2s infinite ease-in-out;
    animation-delay: 0.3s;
  }
  
  @keyframes wave_I6PvD {
    0%, 100% {
      transform: scaleY(0.4);
    }
    25% {
      transform: scaleY(0.8);
    }
    50% {
      transform: scaleY(1.4); 
    }
    75% {
      transform: scaleY(0.8);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/AudioWaves/AudioWaves.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;EACvB;;EAEA;IACE,+BAA+B;IAC/B,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;EACjB;;;;EAIA;IACE,+CAAyC;IACzC,mBAAmB;EACrB;EACA;IACE,+CAAyC;IACzC,qBAAqB;EACvB;EACA;IACE,+CAAyC;IACzC,qBAAqB;EACvB;EACA;IACE,+CAAyC;IACzC,qBAAqB;EACvB;;EAEA;IACE;MACE,sBAAsB;IACxB;IACA;MACE,sBAAsB;IACxB;IACA;MACE,sBAAsB;IACxB;IACA;MACE,sBAAsB;IACxB;EACF","sourcesContent":[".audioSvg {\n    display: inline-block;\n  }\n  \n  .bar {\n    transform-origin: center center;\n    transform-box: fill-box;\n    transform: scaleY(1);\n    animation: none;\n  }\n  \n\n  \n  .audioSvg.recording .bar1 {\n    animation: wave 1.2s infinite ease-in-out;\n    animation-delay: 0s;\n  }\n  .audioSvg.recording .bar2 {\n    animation: wave 1.2s infinite ease-in-out;\n    animation-delay: 0.1s;\n  }\n  .audioSvg.recording .bar3 {\n    animation: wave 1.2s infinite ease-in-out;\n    animation-delay: 0.2s;\n  }\n  .audioSvg.recording .bar4 {\n    animation: wave 1.2s infinite ease-in-out;\n    animation-delay: 0.3s;\n  }\n  \n  @keyframes wave {\n    0%, 100% {\n      transform: scaleY(0.4);\n    }\n    25% {\n      transform: scaleY(0.8);\n    }\n    50% {\n      transform: scaleY(1.4); \n    }\n    75% {\n      transform: scaleY(0.8);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"audioSvg": `audioSvg_oJKAW`,
	"bar": `bar_zGaEH`,
	"recording": `recording_DWHTn`,
	"bar1": `bar1_aD_XT`,
	"wave": `wave_I6PvD`,
	"bar2": `bar2_GbX6U`,
	"bar3": `bar3_f8l3w`,
	"bar4": `bar4_m_OI_`
};
export default ___CSS_LOADER_EXPORT___;
